var map = {
	"./en.json": "NAUj",
	"./fr.json": "OkWW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pJZO";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/rma [A-Za-z0-9-_,\s]+\.json$/
// module id = pJZO
// module chunks = 1